import { tierConsumerReduxKey } from './constants';
function getState(state) {
    if (!state[tierConsumerReduxKey]) {
        return {};
    }
    return state[tierConsumerReduxKey];
}
export const isConsumerReduxReady = (state)=>getState(state).reduxReady;
export const isMatureFilterOverridden = (state, deviationId)=>getState(state).matureFilterOverrides && getState(state).matureFilterOverrides.includes(deviationId);
